import ReactOwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function Testimonial() {
	const {data : {home: {testimonial : {data,name}}}} = useGetSettingQuery()

    return ( 
        <div className="testimonial-section">
			<div className="container">
				<div className="row">
					<div className="col-lg-7 mx-auto text-center mb-4">
						<h2 className="section-title">{name}</h2>
					</div>
				</div>

				<div className="row justify-content-center">
					<div className="col-lg-12" id="slider-wraper">
						<div className="testimonial-slider-wrap text-center">

							{data.lso_comments && <ReactOwlCarousel className="testimonial-slider" loop autoplay center autoplayTimeout={5000} items={1}>
								{data.lso_comments.map((row,index) => 
									<div className="item" key={index}>
										<div className="row justify-content-center">
											<div className="col-lg-8 mx-auto">

												<div className="testimonial-block text-center">
													<blockquote className="mb-5">
														<p>
															&ldquo;
																{row.txe_comment}
															&rdquo;
														</p>
													</blockquote>

													<div className="author-info">
														<div className="author-pic text-center">
															<img src={row.img_image} alt="name" className="img-fluid"/>
														</div>
														<h3 className="font-weight-bold">{row.txt_name}</h3>
														<span className="position d-block mb-3">{row.txt_career}</span>
													</div>
												</div>

											</div>
										</div>
									</div> 
								)}
							</ReactOwlCarousel>}

						</div>
					</div>
				</div>
			</div>
		</div>
    );
}

export default Testimonial;